export const getSettings = () => {
  try {
    const settings = localStorage.getItem('settings');
    if(!settings){
      return initializeSettings();
    }
    return JSON.parse(settings)
  } catch(e) {
    console.log(e)
    return initializeSettings();
  }
}

export const setSettings = (settings) => {
  localStorage.setItem('settings', JSON.stringify(settings))
}
const initializeSettings = () => {

  const emptySettings = {
    hideArchivedSessions: false
  };
  localStorage.setItem('settings', JSON.stringify(emptySettings))
  return emptySettings;
}


